import { Button } from "@/components/core/buttons/button";
import DataTable, { type ColumnDef } from "@/components/core/data-table";
import { Form, FormDescription, FormField, FormGroup, FormIcon, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form";
import { Input } from "@/components/core/forms/input";
import Select from "@/components/core/forms/select";
import { Textarea } from "@/components/core/forms/textarea";
import { Content } from "@/components/layouts/content";
import CaseInfoStatic from "@/features/case-evaluation/case-info-static";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useForm } from "react-hook-form";

export const Route = createFileRoute("/case-filing")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<Content pageName="New Case">
			{/*<Header title="New Case" />*/}
			<div className="flex flex-col w-full max-w-base p-6">
				<div className="mb-20">
					<CaseInfoStatic remarks={false} attachment={false} caseNumber={false} payments={true} upload={true} data={undefined} />
				</div>
			</div>
		</Content>
	);
}
